import { render, staticRenderFns } from "./AssignmentList.vue?vue&type=template&id=f73fae38&scoped=true"
import script from "./AssignmentList.vue?vue&type=script&lang=js"
export * from "./AssignmentList.vue?vue&type=script&lang=js"
import style0 from "./AssignmentList.vue?vue&type=style&index=0&id=f73fae38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73fae38",
  null
  
)

export default component.exports